<div>
  <fz-navbar
    [sticky]="100"
    variant="permanent"
    [theme]="colorScheme"
    [enableSwitchTheme]="true"
  ></fz-navbar>
  <!-- Breadcrumb -->
  <fz-breadcrumbs [sticky]="true" [enableHome]="true"></fz-breadcrumbs>
  <main>
    <router-outlet></router-outlet>
  </main>

  <fz-footer [theme]="colorScheme"></fz-footer>
</div>
